/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M21 9v8.25h1.875c.6213 0 1.125.5037 1.125 1.125s-.5037 1.125-1.125 1.125h-6.75v.6058l-.0082.2485C15.9809 22.4074 14.1721 24 12 24c-2.259 0-4.125-1.7225-4.125-3.8942V19.5h-6.75C.5037 19.5 0 18.9963 0 18.375s.5037-1.125 1.125-1.125H3V9c0-4.9706 4.0294-9 9-9 4.8576 0 8.8164 3.8484 8.9938 8.6626L21 9ZM10.125 20.1058l.0108.1755c.0321.2608.1349.506.2925.7187.3313.4471.9046.75 1.5717.75.6671 0 1.2404-.3029 1.5717-.75.1925-.2598.3033-.5682.3033-.8942V19.5h-3.75v.6058ZM5.25 9l.0073-.3178C5.4234 5.1018 8.3787 2.25 12 2.25l.3178.0074C15.8981 2.4233 18.75 5.3786 18.75 9v8.25H5.25V9Z"
    clipRule="evenodd"
  />,
  'MenuAlerts'
);
